import { AxiosResponse } from 'axios';

import { ProductService } from '../../../models/product-service';
import { SFCCBasket } from '../../../models/sfcc-basket';
import { makeCurrentBasketAction } from '../../../utilities/make-current-basket-action';
import { shopHttp } from '../../basket-api';

interface PatchProductBody {
  quantity: number;
  c_productLineItemID: string;
  c_services?: ProductService[];
  c_engravingMsg?: string;
}

export const patchProduct = async (
  itemId: string,
  quantity: number,
  ensureBasketMethod: () => Promise<SFCCBasket>,
  engravingMessage?: string,
  services?: ProductService[]
): Promise<SFCCBasket> => {
  const productItem: PatchProductBody = {
    quantity,
    c_productLineItemID: itemId,
  };

  if (services) productItem.c_services = services;
  if (engravingMessage) productItem.c_engravingMsg = engravingMessage;

  return await makeCurrentBasketAction(
    `items/${itemId}`,
    patchProductInBasket,
    ensureBasketMethod,
    productItem
  );
};

const patchProductInBasket = async (
  requestPath: string,
  body: PatchProductBody
): Promise<SFCCBasket> => {
  const response = await shopHttp.patch<PatchProductBody, AxiosResponse<SFCCBasket>>(
    requestPath,
    body
  );

  return response.data;
};
